import {hasUserProfilingConsent} from '../services/privacyService';
import storage from './storage';

export function getSnowplowId(): string | null {
	if (!hasUserProfilingConsent()) {
		return null;
	}

	return storage.get('_sp_id');
}
